<div class="filter-container">

  @if (feature === 'inventaire') {
    <div id="history-block">
      <div id="history-header"
           [class.collapsed]="!isHistoryVisible"
           (click)="isHistoryVisible = !isHistoryVisible">
        <i id="history-icon" class="fas fa-history"></i>
        <span><strong>Historisation d'inventaire</strong></span>
        <i id="history-visible-indicator" class="fas fa-chevron-down" [class.collapsed]="!isHistoryVisible"></i>
      </div>

      <div id="history-body"
           [class.collapsed]="!isHistoryVisible">
        <yo-lookup
          [data]="historySites"
          [autoSelect]="false"
          [selectedItem]="historySiteSelected"
          (onValueChange)="onHistorySiteSelected($event)"
          [showClearButton]="true"
          placeholder="Sélectionner une unité de production">
        </yo-lookup>

        <yo-date-picker
          [disabled]="!historySiteSelected"
          [selectLevel]="DateLevelEnum.MONTH"
          [displayLevel]="DateLevelEnum.DAY"
          [availableDates]="availableHistoriqueDates"
          [value]="histoDate"
          [allowManualEvents]="false"
          (onValueChange)="onHistoDateSelected($event)"
          placeholder="Date de validation">
        </yo-date-picker>

        <yo-date-picker
          [disabled]="!histoDate"
          [availableDates]="inventaireDatesDisponibles"
          [value]="inventaireDate"
          (onValueChange)="onInventaireDateSelected($event)"
          placeholder="Date d'inventaire constaté">
        </yo-date-picker>

        <yo-lookup
          [disabled]="!inventaireDate"
          [data]="typesAlimentaire"
          [selectedItem]="typeAlimentaireSelected"
          (onValueChange)="onTypeAlimentaireChanged($event)"
          [showClearButton]="true"
          [autoSelect]="false"
          placeholder="Alimentaire / Non Alimentaire">
        </yo-lookup>

        <yo-button
          id="history-save"
          [iconClass]="isSavingHistorique ? 'fas fa-spinner fa-spin' : 'fas fa-save'"
          [label]="isSavingHistorique ? 'Validation en cours...' : 'Valider l\'inventaire'"
          [theme]="ButtonThemeEnum.DEFAULT"
          [disabled]="isSavingHistorique || (!historySiteSelected && !histoDate)"
          (onClick)="saveHistoriqueInventaire()">
        </yo-button>
      </div>
    </div>

    <yo-dialog-conflit-inventaire
      [(displayDialog)]="displayConflitInventairePopup"
      [conflitList]="conflitList()">
    </yo-dialog-conflit-inventaire>
  }

  <div class="filter-header">
    <i class="fas fa-filter filter-header-icon-container"></i>
    <span><strong>Filtres de recherche</strong></span>
  </div>

  <form [formGroup]="formSearch" class="filter-form">

    <div class="filter-form-container">
      <div class="filter-form-inputs">
        <input type="text"
               formControlName="denominationArticle"
               placeholder="Libellé article">
        <input type="text"
               formControlName="referenceInterneArticle"
               placeholder="Réf. article">
        <input type="text"
               formControlName="denree"
               placeholder="Libellé Matière Première">
        <input type="text"
               formControlName="codeDenree"
               placeholder="Code Matière Première">
        <dx-date-box id="dateLivStart"
                     placeholder="Entrée à partir du"
                     type="date"
                     formControlName="dateEntree">
        </dx-date-box>
        <dx-date-box id="dateLivEnd"
                     placeholder="Périmé avant le"
                     type="date"
                     formControlName="datePeremption">
        </dx-date-box>
      </div>
    </div>

    <div class="filter-form-container"
         [class.hidden]="isHistoryMode">
      <div class="filter-form-inputs">
        <dx-radio-group
          formControlName="thresholdStocks"
          valueExpr="value"
          displayExpr="label"
          [items]="seuils">
        </dx-radio-group>
      </div>
    </div>

    <div class="filter-form-container"
         [class.hidden]="isHistoryMode">
      <div class="filter-form-inputs">
        <yo-lookup
          [data]="typesAlimentaire"
          [selectedItem]="typeAlimentaireSelected"
          (onValueChange)="onTypeAlimentaireChanged($event)"
          [showClearButton]="true"
          [autoSelect]="false"
          placeholder="Alimentaire / Non Alimentaire">
        </yo-lookup>
      </div>
    </div>

    <div class="filter-form-container"
         [class.hidden]="isHistoryMode">
      <div class="filter-form-inputs">
        <dx-list
          [dataSource]="sites"
          [height]="250"
          selectionMode="all"
          selectAllMode="allPages"
          displayExpr="libelle"
          keyExpr="id"
          [showSelectionControls]="true"
          [searchEnabled]="true"
          [selectedItemKeys]="idsSitesSelected"
          (onSelectionChanged)="onChangeSite($event)"
          [disabled]="isHistoryMode"
          searchExpr="libelle"
          searchMode="contains">
          <dxo-search-editor-options
            placeholder="Filtrer par site">
          </dxo-search-editor-options>
        </dx-list>
      </div>
    </div>

    <div class="filter-form-container">
      <div class="filter-form-inputs">
        <dx-tree-view
          #treeViewZonesStockages
          [dataSource]="zonesStockages"
          [height]="250"
          keyExpr="id"
          selectionMode="multiple"
          showCheckBoxesMode="normal"
          [selectNodesRecursive]="true"
          [selectByClick]="true"
          [searchEnabled]="true"
          (onItemSelectionChanged)="changeZoneStockage($event)"
          [searchEditorOptions]="{placeholder: 'Filtrer par zone de stockage'}"
          searchExpr="label"
          searchMode="contains"
          itemTemplate="itemTemplate">
          <div *dxTemplate="let item of 'itemTemplate'">
            <i class="{{ item.icon }}"></i> {{ item.label }}
          </div>
        </dx-tree-view>
      </div>
    </div>

  </form>
</div>
